import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import webrecharge from '@utils/webrecharge';
import webLogin from '@utils/weblogin';
import util from '@utils/util';
import videoService from '@services/videoService';
import lmPopup from '@ui/packages/pcv2/basic/lm-popup/index';
import commonMixin from '@ui/packages/pcv2/pages/page-live/src/mixins/common';
import Intercept from '@ui/packages/pcv2/pages/page-live/src/mixins/Intercept';
import Liveroom from './Liveroom';
import loginReg from '../../../../../basic/login-reg/src/wrap';
import recommendedlist from './RecommendedList';
// import jieMeiTao from './JieMeiTao';

export default {
  name: 'PageLive',
  mixins: [commonMixin, Intercept],
  data: function data() {
    return {
      VideoAPIService: null,
      authentication: null,
      channel: null,
      minimum: false,
      exploreList: null
      // isShowJmt: false,
    };
  },
  components: {
    Liveroom: Liveroom,
    loginReg: loginReg,
    recommendedlist: recommendedlist,
    // jieMeiTao,
    lmPopup: lmPopup
  },
  methods: {
    parameters: function parameters() {
      return this.$route.query;
    },
    onSkipLiveRoom: function onSkipLiveRoom(vid) {
      this.channel = vid;
    },
    /**
        * 获取authenticate，如果没有，自动弹出登陆
        */
    authenticateHandler: function authenticateHandler() {
      if (webLogin.checkLogin()) {
        this.authentication = webLogin.getAuthentication();
      } else {
        this.$refs.logReg.showFrame();
        util.KEWLSensorTrack({
          lmweb_clickText: '唤起登陆'
        });
        // 通知头部登陆失效
        this.$lmBus && this.$lmBus.$emit('Header-Login-Out-Handle');
      }
    },
    /**
        * 登陆成功后获取authentication，关闭登陆页面
        */
    successHandle: function successHandle(data) {
      this.authentication = webLogin.getAuthentication();
      this.$refs.logReg.closeFrame();
      this.$lmBus && this.$lmBus.$emit('Header-Login-Success-Handle', data);
    },
    /**
        * 退出登陆
        */
    logoutHandle: function logoutHandle() {
      this.$lmBus && this.$lmBus.$emit('Header-Login-Out-Handle');
      this.authentication = webLogin.getAuthentication();
      this.$refs.logReg.closeFrame();
    },
    /**
        * 获取推荐的视频
        */
    getFeatureList: function getFeatureList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var countryCode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return util.getI18nCountryCode(_this.$route && _this.$route.params.countryCode);
            case 2:
              countryCode = _context.sent;
              _context.next = 5;
              return _this.VideoAPIService.getFeatureList(countryCode.toUpperCase(), _this.pageIndex, 1);
            case 5:
              return _context.abrupt("return", _context.sent.video_info);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    rechargeHandler: function rechargeHandler() {
      util.loadingFunc({
        time: 3000
      });
      webrecharge.doRecharge();
    },
    nextChannelHandler: function nextChannelHandler() {
      // console.log('going next channel...');
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this2.VideoAPIService = videoService.createApi();
            _context2.next = 3;
            return _this2.getFeatureList();
          case 3:
            _this2.exploreList = _context2.sent;
            _this2.authentication = webLogin.getAuthentication();
            _this2.channel = _this2.$route && _this2.$route.params.videoid || _this2.exploreList[0].vdoid;
            // const countryCode = await util.getI18nCountryCode(this.$route && this.$route.params.countryCode);
            // if (util.isTW(countryCode)) {
            //     this.isShowJmt = true;
            // }
            // 查询 是否可以进入主播
            _context2.next = 8;
            return _this2.getLiveRoomInfo();
          case 8:
            _this2.$nextTick(function () {
              _this2.$refs.liveroomModel && _this2.$refs.liveroomModel.updateChannel();
            });
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  mounted: function mounted() {
    var _this3 = this;
    this.$lmBus && this.$lmBus.$on('Live-Login-Success-Handle', function (data) {
      if (data) {
        _this3.authentication = null;
        _this3.authentication = webLogin.getAuthentication();
        _this3.getLiveRoomInfo(true);
      }
    });
    this.$lmBus && this.$lmBus.$on('Live-Login-Out-Handle', function () {
      _this3.authentication = null;
    });
  }
};